import { useState } from 'react'
import { apiDelete, apiGet, apiPost, apiPut } from '../../generic/Api_Functions'
import SmartMateriaUITable from '../../generic/SmartMateriaUITable'
import { useSmartTranslation } from '../../generic/hooks/useSmartTranslation'
import { SmartDialog } from '../../generic/utilities/SmartDialog'
import { TextSnippetOutlined, SettingsOutlined } from '@mui/icons-material'
import { IconButton } from '@mui/material'
import Document from '../document/Document'
import { useNavigate } from 'react-router-dom'
import useRepositorySelection from '../../generic/hooks/useRepositorySelection'
import { parentPreselectedRecordFrom } from '../../generic/utilities/repositorySelectionMapping'
const DeviceGroup = () => {
  const { t_ } = useSmartTranslation()
  const [showDocument, setShowDocument] = useState(false)
  const [isDownloadingFile, setIsDownloadingFile] = useState(false)
  const [deviceGroupRow, setDeviceGroupRow] = useState(null)
  const [editing, setEditing] = useState(false)
  const navigate = useNavigate()
  // Historia 170 (J4b, S89): DEVICE_GROUP has no child window in the Gherkin contract — only this
  // table itself preselects.
  const repositorySelection = useRepositorySelection()

  const columns = [{
    name: t_('Code'),
    field: 'code',
    charLimit: 60,
    mandatory: true,
    unique: true
  },
  {
    name: t_('Name'),
    field: 'name',
    charLimit: 80,
    mandatory: true,
    unique: true
  },
  {
    name: t_('Description'),
    field: 'description',
    charLimit: 200
  },
  {
    name: t_('Assets'),
    field: 'devices.name',
    type: 'smartMultiSelect',
    edit: {
      source: async () => {
        return await apiGet('devicesBasicData')
      },
      id: 'id',
      field: 'name'
    },
    mandatory: true
  },
  {
    name: t_('Type'),
    field: 'deviceGroupType.code',
    type: 'select',
    defaultNewValue: { code: 'GROUP', id: 4 },
    edit: {
      source: async () => {
        return await apiGet('deviceGroupTypes')
      },
      id: 'id',
      field: 'code'
    },
    mandatory: true
  }
  ]

  const actions = {
    custom: [
      {
        name: 'Documents',
        render: (row) => {
          return (
            <IconButton>
              <TextSnippetOutlined />
            </IconButton>
          )
        },
        onClick: (row) => {
          setDeviceGroupRow(row)
          setShowDocument(true)
        },
        disabled: (row) => (editing && editing.id === row.id)
      },
      {
        name: t_('Configuration'),
        render: (row) => {
          return (
            <IconButton>
              <SettingsOutlined />
            </IconButton>
          )
        },
        onClick: (row) => {
          navigate('/configuration/assetGroups/' + row.id)
        },
        disabled: (row) => (editing && editing.id === row.id) || (row.deviceGroupType.code !== 'CELL' && row.deviceGroupType.code !== 'LINE')
      }
    ],
    edit: {
      fetchFunction: (row) => {
        return apiPut('deviceGroup', row)
      }

    },
    create: {
      fetchFunction: (row) => {
        return apiPost('deviceGroup', row)
      }
    },
    delete: {
      fetchFunction: (rows) => {
        if (rows.length === 1) {
          return apiDelete('deviceGroup/' + rows[0].id, rows)
        } else {
          return apiDelete('deviceGroupsDeleteMulti', rows)
        }
      }
    }
  }

  const fetchFunction = async (pagination) => {
    const deviceGroups = await apiGet('deviceGroups', pagination)
    return deviceGroups
  }
  return (
    <>
      <SmartDialog
        closeCallback={() => setShowDocument(false)}
        accept={false}
        cancel={false}
        close
        disableButtons={isDownloadingFile}
        renderComponent={<Document reference={deviceGroupRow} resourceType='DEVICE_GROUP' isDownloadingFile={isDownloadingFile} setIsDownloadingFile={setIsDownloadingFile} />}
        setOpen={showDocument}
      />
      <SmartMateriaUITable
        tableTuneUniqueKey='AssetGroups'
        columns={columns}
        title={t_('Asset Groups')}
        dataFetch={fetchFunction}
        actions={actions}
        multipleSelection
        multipleOptions
        pageable
        preselectedRecord={parentPreselectedRecordFrom(repositorySelection)}
        editingRow={(event) => setEditing(event)}
      />
    </>

  )
}

export default DeviceGroup
